<div id="crop-health-note-all">
  <p class="page-title">
    <i class="ph-bold ph-caret-left back-icon" (click)="returnToPreviousPage()"></i>
    <span>{{ 'doktar_app.services.crop_monitoring.note_list_title' | translate }}</span>
  </p>

  <div class="filter-container">
    <div class="filter-item">
      <svg
        class="search-icon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="7.06484" cy="7.10281" rx="5.73281" ry="5.76883" fill="#CBCBCB" />
        <path
          d="M13.783 14.637C13.5603 14.6298 13.3486 14.5382 13.1902 14.3805L11.8326 12.7936C11.5415 12.5274 11.5177 12.0751 11.7792 11.7794C11.9016 11.6556 12.068 11.5859 12.2416 11.5859C12.4152 11.5859 12.5816 11.6556 12.704 11.7794L14.4114 13.1456C14.6574 13.3973 14.7333 13.771 14.6052 14.0997C14.4771 14.4283 14.169 14.6505 13.8186 14.6668L13.783 14.637Z"
          fill="#CBCBCB" />
      </svg>

      <input
        type="text"
        [placeholder]="'doktar_app.common.search_placeholder' | translate"
        [(ngModel)]="searchText"
        (keyup)="onSearch()" />
    </div>
    <div class="filter-item filter-tool" (click)="onOpenFilterModal()">
      <i class="ph-fill ph-sliders-horizontal"></i>
    </div>
    <div class="filter-item filter-tool" (click)="sortPopover.toggle($event)">
      <i class="ph ph-sort-ascending"></i>
      <p-popover #sortPopover>
        <div id="land-plantation-popover" class="sort-popover">
          @for (item of sortOptions; track item.value; let index = $index) {
            <div class="sort-item-row" (click)="onSelectSortItem(index)">
              <span>{{ item.label | translate }}</span>
              @if (!item.selected) {
                <i class="ph ph-circle icon"></i>
              } @else {
                <i class="ph-fill ph-radio-button icon"></i>
              }
            </div>
          }
        </div>
      </p-popover>
    </div>
  </div>

  <div class="row">
    @if (!loading) {
      @if (filteredNotes.length > 0) {
        @for (note of filteredNotes; track note) {
          <div class="col-12 col-md-6 col-lg-4 mb-4">
            <div class="box">
              <app-crop-health-note-item
                [note]="note"
                (getAllNotes)="getAllNotes.emit()"
                (viewNote)="viewNote.emit($event)" />
            </div>
          </div>
        }
      } @else {
        @if (filterParameters) {
          <div class="no-result-found">
            <span class="icon">
              <i class="ph-fill ph-warning icon"></i>
            </span>
            <p class="title">{{ 'doktar_app.common.no_results_found' | translate }}</p>
            <p class="description">
              {{ 'We couldnt find any items matching your criteria. Please try adjusting your filters.' | translate }}
            </p>
            <dk-button
              severity="primary"
              [label]="'doktar_app.common.reset_to_default' | translate"
              (onClick)="resetFilter()" />
          </div>
        }
      }
    } @else {
      @for (item of [1, 2, 3, 4, 5, 6]; track item) {
        <div class="col-12 col-md-6 col-lg-4 mb-4">
          <p-skeleton width="100%" height="16rem" />
        </div>
      }
    }
  </div>
</div>
